// @ts-check
import { defineConfig } from '../utils';

export function internalConfigurations() {
  return defineConfig({
    properties: {
      'ConfiguracionesInternas.AccesoHabilitado': {
        defaultValue: false,
        resetOnLogout: true,
      },
      'ConfiguracionesInternas.MostrarTodasOpcionesMenu': {
        defaultValue: false,
      },
      'ConfiguracionesInternas.MostrarBaseDatosUsada': {
        defaultValue: true,
      },
      'ConfiguracionesInternas.TipoAgrupacionParametros': {
        /** @type {'none' | 'module' | 'process' | 'source'} */
        defaultValue: 'none',
      },
    },
  });
}
